export const enum CompactCompanyLibraryMenuItems {
  PRODUCTS = 'products',
  LIFESTYLES = 'lifestyles',
  MATERIALS = 'materials',
  NEW_PRODUCTS = 'new-library/products',
  NEW_LIFESTYLES = 'new-library/lifestyles',
  NEW_MATERIALS = 'new-library/materials',
  NEW_TWINS = 'new-library/twins'
}
